import { render, staticRenderFns } from "./ServiceInconsistency.vue?vue&type=template&id=50b87b3c&scoped=true"
import script from "./ServiceInconsistency.vue?vue&type=script&lang=js"
export * from "./ServiceInconsistency.vue?vue&type=script&lang=js"
import style0 from "./ServiceInconsistency.vue?vue&type=style&index=0&id=50b87b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b87b3c",
  null
  
)

export default component.exports